export type AICreationErrorCode =
  | 'unexpected_error'
  | 'safety_reject'
  | 'service_unavailable'
  | 'image_too_large'
  | 'image_processing_failed'
  // For unknown error codes
  // eslint-disable-next-line @typescript-eslint/ban-types
  | (string & {})

export class AICreationError extends Error {
  constructor(public errorCode: AICreationErrorCode) {
    super(`AI Creation failed with error code: ${errorCode}`)
    this.name = 'AICreationError'
  }
}

export const KIDS_LOADING_TEXTS = [
  'Creation started...',
  'Collecting magical details…',
  'Exploring favorite hobbies…',
  'Mixing in special ingredients…',
  'Sketching a brand-new art…',
  'Adding personal touches…',
  'Bringing your masterpiece to life…',
  'Your new art is almost ready…',
]

export const KIDS_LOADING_INFO = 'Usually takes about 1–2 minutes'

export const DYNAMIC_WALL_BG_MOBILE =
  'https://res.cloudinary.com/mixtiles/image/upload/f_auto,q_auto:good/c_scale,w_1200/photo-to-art/wall-preview/mobile-wall-preview.png'
export const DYNAMIC_WALL_BG_DESKTOP =
  'https://res.cloudinary.com/mixtiles/image/upload/f_auto,q_auto:good/c_scale,w_1200/photo-to-art/wall-preview/desktop-wall-preview.png'

export const uploadMenuTransitionConfig = {
  duration: 0.2,
}

export const PET_SUBJECT_TEMPLATE_SLUGS = new Set([
  'caricature-drawing',
  'caricature_drawing_gpt2',
])
